const SectionMap = Class(
  /**
   * @lends {SectionMap#}
   */
  {

    __construct () {
      this.node = mkE({
        tag: 'div',
        id: 'SectionMap',
      }).append(this.layout.ct());
    },

    draw () {
      this.apiCall.onLoad = this._onLoad;

      this._mGetFilter = new DR.events.GetFilter();
      this.apiCall.addMethod(this._mGetFilter);

      this.apiCall.call();
    },

    _onLoad () {
      mkE({
        tag: 'div',
        id: 'T__EventsList',
        els: [
          this._map = new T.EventsSearchMap({
            method: this._mGetFilter,
            noAjax: true
          })
        ]
      }).append(this.node);
      if (D.CSS.brTablet) {
        this.addBodyClass('popup-open');
      }
      let country = this._map._filter.getCountry() || '';
      let countries = this._mGetFilter.re.countries;
      if (!country && D.LANG !== 'en' && countries.indexOf(D.LANG) !== -1) {
        country = D.LANG;
      }
      let bounds = this._mGetFilter.re.countryBounds[country] || {
        south: 34,
        west: -11,
        north: 65,
        east: 55
      };
      this._map.search({
        south: bounds.south,
        west: bounds.west,
        north: bounds.north,
        east: bounds.east
      });
      this.ready();
    }

  },
  Section
);
